import { render } from "./Congresses.vue?vue&type=template&id=b4cef51e"
import script from "./Congresses.vue?vue&type=script&lang=js"
export * from "./Congresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__